import type { SaveData } from '../types';
import { SaveSystem } from './SaveSystem';

let _data: SaveData | null = null;

export const GameState = {
  get data(): SaveData {
    if (!_data) throw new Error('GameState not initialized. Call initialize() first.');
    return _data;
  },

  initialize(playerName: string): void {
    _data = SaveSystem.load() ?? SaveSystem.createNewSave(playerName);
  },

  persist(): void {
    if (_data) SaveSystem.save(_data);
  },

  reset(): void {
    _data = null;
    SaveSystem.reset();
  },

  isInitialized(): boolean {
    return _data !== null;
  },
};
